import React, { memo, useCallback } from "react";
import { style as bulletsStyle } from "./Bullets.style";
import "./Bullets.web.css";
const MAX = 5;
const DIAMETER_MAX = 8;
const DIAMETER_MIN = 2;
const Bullet = memo(({ index, activeIndex, maxBullets }) => {
    const { colorBgPrimary } = bulletsStyle();
    const pivot = Math.floor(maxBullets / 2) + 1;
    const delta = Math.abs(index - activeIndex);
    const diameter = delta > 1 ? DIAMETER_MAX - delta * DIAMETER_MIN : DIAMETER_MAX;
    const opacity = delta === 0 ? 1 : 0.3;
    if (delta >= pivot)
        return null;
    return (React.createElement("li", { className: "bullet-item" },
        React.createElement("button", { "aria-label": `Bullet ${index + 1} of ${maxBullets}`, "aria-selected": delta === 0, className: "bullet-button", "data-index": index, "data-testid": "bullet", type: "button", style: {
                backgroundColor: colorBgPrimary,
                width: diameter,
                height: diameter,
                borderRadius: DIAMETER_MAX,
                opacity,
            } })));
});
Bullet.displayName = "Bullet";
const Bullets = ({ activeIndex, count, maxBullets = MAX, onChange, testID = "bullets" }) => {
    const { bullets } = bulletsStyle();
    const handleClick = useCallback((e) => {
        const target = e.target.closest("[data-index]");
        if (!target)
            return;
        const idx = Number(target.dataset.index);
        if (!Number.isNaN(idx))
            onChange(idx);
    }, [onChange]);
    return (React.createElement("ul", { className: "bullets-list", "data-testid": testID, style: { ...bullets }, onClick: handleClick }, [...Array(count).keys()].map((index) => (React.createElement(Bullet, { key: index, activeIndex: activeIndex, index: index, maxBullets: maxBullets })))));
};
export { Bullets };
